import React from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import { isFunction, isString } from 'lodash';

class CollapseElement extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      open: false
    };
  }

  render () {
    const { open } = this.state;
    const { onClickFn, buttonText } = this.props;

    return (
      <div>
        <button
          className={this.props.buttonClassname}
          onClick={(e) => {
            e.preventDefault();
            this.setState({ open: !open });
            if (isFunction(onClickFn)) onClickFn();
          }}
          aria-controls="collapse-text"
          aria-expanded={open}
          type="button"
        >
          {
            isString(buttonText) ?
              buttonText :
              React.cloneElement(buttonText, { isCollapseOpen: open })
          }
        </button>

        <Collapse in={this.state.open}>
          { this.props.children }
        </Collapse>
      </div>
    );
  }
}

CollapseElement.propTypes = {
  buttonText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  buttonClassname: PropTypes.string,
  children: PropTypes.element,
  onClickFn: PropTypes.func
};

export default CollapseElement;
